import { Component, OnInit } from '@angular/core';
import { CidadeService } from '../cidade.service';
import { CidadeDto } from '../cidade.model';
import { NotificationService } from '../../../core/notification.service';

@Component({
  standalone: false,
  selector: 'app-cidades-list',
  template: `
    <div class="container mx-auto px-4 py-6">
      <div class="flex items-center justify-between mb-6">
        <div>
          <h1 class="text-3xl font-bold text-gray-800">🌆 Cidades</h1>
          <p class="text-gray-600 mt-1">Gerencie as cidades disponíveis na plataforma</p>
        </div>
        <a routerLink="/admin/cidades/new" class="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">+ Nova Cidade</a>
      </div>

      <div class="bg-white rounded-lg shadow overflow-hidden">
        <div *ngIf="loading" class="text-center py-12 text-gray-500">Carregando...</div>

        <div *ngIf="!loading && items.length === 0" class="text-center py-12 text-gray-500">
          Nenhuma cidade cadastrada ainda.
          <div class="mt-3">
            <a routerLink="/admin/cidades/new" class="text-blue-600 hover:underline">Cadastrar a primeira cidade →</a>
          </div>
        </div>

        <table *ngIf="!loading && items.length > 0" class="w-full">
          <thead class="bg-gray-50 border-b border-gray-200">
            <tr>
              <th class="text-left px-4 py-3 text-sm font-semibold text-gray-700">Nome</th>
              <th class="text-left px-4 py-3 text-sm font-semibold text-gray-700">Estado (UF)</th>
              <th class="text-left px-4 py-3 text-sm font-semibold text-gray-700">Slug</th>
              <th class="text-left px-4 py-3 text-sm font-semibold text-gray-700">Status</th>
              <th class="text-right px-4 py-3 text-sm font-semibold text-gray-700">Ações</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100">
            <tr *ngFor="let c of items" class="hover:bg-gray-50 transition">
              <td class="px-4 py-3 font-medium text-gray-900">{{ c.nome }}</td>
              <td class="px-4 py-3 text-gray-700">{{ c.estado }}</td>
              <td class="px-4 py-3 text-gray-500 font-mono text-sm">{{ c.slug || '—' }}</td>
              <td class="px-4 py-3">
                <span [class]="c.ativo !== false ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'"
                  class="px-2 py-0.5 rounded-full text-xs font-medium">
                  {{ c.ativo !== false ? '✓ Ativa' : '✗ Inativa' }}
                </span>
              </td>
              <td class="px-4 py-3 text-right">
                <a [routerLink]="['/admin/cidades', c.id, 'edit']"
                  class="text-blue-600 hover:text-blue-800 text-sm mr-4">Editar</a>
                <button (click)="onDelete(c)" class="text-red-600 hover:text-red-800 text-sm">Excluir</button>
              </td>
            </tr>
          </tbody>
        </table>

        <div *ngIf="!loading && total > pageSize" class="flex items-center justify-between px-4 py-3 border-t border-gray-200">
          <div class="text-sm text-gray-600">Mostrando {{ items.length }} de {{ total }} cidades</div>
          <div class="flex gap-2">
            <button (click)="prev()" [disabled]="page <= 1"
              class="px-3 py-1 border rounded text-sm disabled:opacity-50">← Anterior</button>
            <span class="px-3 py-1 text-sm">Página {{ page }}</span>
            <button (click)="next()" [disabled]="page * pageSize >= total"
              class="px-3 py-1 border rounded text-sm disabled:opacity-50">Próxima →</button>
          </div>
        </div>
      </div>
    </div>
  `
})
export class CidadesListComponent implements OnInit {
  items: CidadeDto[] = [];
  page = 1;
  pageSize = 20;
  total = 0;
  loading = false;

  constructor(private svc: CidadeService, private notify: NotificationService) {}

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.svc.adminList(this.page, this.pageSize).subscribe({
      next: (res: any) => {
        this.items = res?.data ?? (Array.isArray(res) ? res : []);
        this.total = res?.meta?.total ?? this.items.length;
        this.loading = false;
      },
      error: (err: any) => {
        console.error('[CidadesList] erro ao carregar', err);
        this.notify.showError('Erro ao carregar cidades');
        this.loading = false;
      }
    });
  }

  prev(): void {
    if (this.page > 1) {
      this.page--;
      this.load();
    }
  }

  next(): void {
    if (this.page * this.pageSize < this.total) {
      this.page++;
      this.load();
    }
  }

  onDelete(c: CidadeDto): void {
    if (!confirm(`Excluir a cidade "${c.nome}"?`)) return;
    this.svc.delete(c.id).subscribe({
      next: () => {
        this.notify.showSuccess('Cidade excluída com sucesso');
        this.items = this.items.filter(i => i.id !== c.id);
        this.total = Math.max(0, this.total - 1);
      },
      error: (err: any) => {
        console.error('[CidadesList] erro ao excluir', err);
        this.notify.showError('Erro ao excluir cidade');
      }
    });
  }
}
